import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "69",
  height: "24",
  fill: "none",
  viewBox: "0 0 69 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "finq-logo" }, [
      _createElementVNode("path", {
        id: "Vector",
        fill: "#222",
        d: "M17.7 23.2h2.85V.8H17.7v22.4ZM0 23.2h2.85v-9.85H13.6v-2.6H2.85V3.42L14.7 3.4V.8H0v22.4Zm40.35-3.45h-.15L28.15.8H24.2v22.4h2.85V4.25h.15L39.25 23.2h3.95V.8h-2.85v18.95Zm22.38 0c2.95-1.38 4.77-3.93 4.77-7.75s-1.95-6.54-5.08-7.88C60.92 1.6 58.71 0 56.25 0s-4.67 1.6-6.17 4.12C46.95 5.47 45 8.05 45 12c0 3.95 1.95 6.54 5.08 7.88 1.5 2.52 3.71 4.12 6.17 4.12s4.6-1.55 6.1-4c.85 1.06 3.42 2.84 6.65 4v-4.25h-6.27Zm-.53-.22c-1.68.71-3.7 1.07-5.95 1.07s-4.28-.35-5.95-1.07c-1.06-2.06-1.7-4.68-1.7-7.53 0-2.85.64-5.47 1.7-7.53 1.68-.71 3.7-1.07 5.95-1.07s4.28.35 5.95 1.07c1.06 2.06 1.7 4.68 1.7 7.53 0 2.85-.64 5.47-1.7 7.53Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "finq-logo-full"}) } }